






import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop} from 'vue-property-decorator';
import {Inject} from 'inversify-props';

import {ISettingsService} from '@/services/settings/ISettings.service';
import {Formatters} from '@/utils/Formatters';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component
export default class PieChart extends Mixins<BaseComponent>(BaseComponent) {

  @Prop()
  public labels!: string[];

  @Prop()
  public values!: number[];

  @Prop()
  public colors!: string[];

  @Prop({type: String, default: 'auto'})
  public height!: string;

  @Prop({type: String, default: 'bottom'})
  public legendPosition!: string;

  @Inject(Symbol.for('ISettingsService'))
  private settingsService!: ISettingsService;

  get options() {
    return {
      labels: this.labels,
      colors: this.colors,
      tooltip: {
        enabled: false,
      },
      chart: {
        type: 'donut',
        animations: {
          enabled: false,
          animateGradually: {
            enabled: false,
          },
          dynamicAnimation: {
            enabled: false,
          },
        },
      },
      dataLabels: {
        enabled: true,
        formatter: (percent: number) => `${percent.toFixed(0)}%`,
      },
      plotOptions: {
        pie: {
          expandOnClick: false,
          donut: {
            size: '60%',
            labels: {
              show: true,
              value: {
                formatter: (val: number) => isNaN(val) ? val : Formatters.Bytes(val, 0),
              },

              total: {
                show: true,
                label: 'Total',
                color: 'darkgrey',
                formatter: (w: any) => {
                  const total = w.globals.seriesTotals.reduce((a: number, b: number) => {
                    return a + b;
                  }, 0);
                  if (isNaN(total)) {
                    return total;
                  } else {
                    return Formatters.Bytes(total, 0);
                  }
                },
              },
            },
          },
        },
      },
      legend: {
        show: this.legendPosition !== 'hidden',
        position: this.legendPosition === 'hidden' ? 'bottom' : this.legendPosition,
        horizontalAlign: 'center',
      },
    };
  }
}
